import {
	// onInputCellChange,
	// moveToCellSheet,
	headerFormat,
	colName,
	clearExcelData,
} from 'utils/excelUtils/ExcelDataPopulate';
import { formatDate } from 'utils/dateUtil';

const COLUMN_TEXT = {
	PhoenixTimePeriod: {
		client: 'Client',
		workspaceType: 'Workspace Type',
		analysisLevel: 'Analysis Level',
		template: 'Template',
		accountId: 'Account/Group',
		hierarchy: 'Hierarchy',
		hierarchyLevel: 'Hierarchy Level',
		referancedate: 'As Of Date',
		fee: 'Fee',
		benchmark: 'Benchmark',
	},
	PhoenixTimeSeries: {
		client: 'Client',
		workspaceType: 'Workspace Type',
		analysisLevel: 'Analysis Level',
		template: 'Template',
		accountId: 'Account/Group',
		hierarchy: 'Hierarchy',
		hierarchyLevel: 'Hierarchy Level',
		startdate: 'Start Date',
		enddate: 'End Date',
		fee: 'Fee',
		benchmark: 'Benchmark',
	},
};

const renderInputToCell = (range, value) => {
	// dataRangeUpdate(data, range, key);
	range.values = value;
	// const endRange = row + 2;
	// updateInputCellStorage(col, endRange);
	range.format.columnWidth = 230;
	range.format.wrapText = true;
	range.format.autofitColumns();
};

export const renderInputSelectionToExcel = (data, serviceId, callback) => {
	// isClearRenderTitle(isGetDataClicked);
	if (data.inputEndRange) {
		const cellSheet = data.inputEndRange.sheetName;
		clearExcelData(data.inputEndRange.cellRange, cellSheet);
	}
	let row = 0;
	let col = 0;
	Excel.run(context => {
		const inputColumns = COLUMN_TEXT[serviceId];
		const sheet = context.workbook.worksheets.getItem(data.sheetName);
		sheet.activate();
		const startRange = sheet.getRange(data.cellNumber);
		startRange.load('rowIndex');
		startRange.load('columnIndex');
		return context
			.sync()
			.then(() => {
				row = startRange.rowIndex;
				col = startRange.columnIndex;
				// let isSingleTimePeriod;
				Object.keys(inputColumns).map(key => {
					let range = sheet.getCell(row, col);
					if (key === 'accountId' && data[key].length > 0) {
						const selectedAcc = data[key]
							.map(i => i.text)
							.join(', ');
						range.values = inputColumns[key];
						headerFormat(range);
						range = sheet.getCell(row + 1, col);
						renderInputToCell(range, selectedAcc);
						col += 1;
					} else if (data[key]?.text) {
						range.values = inputColumns[key];
						headerFormat(range);
						range = sheet.getCell(row + 1, col);
						const val =
							key === 'referancedate' ||
							key === 'startdate' ||
							key === 'enddate'
								? formatDate(data[key].text, 'mm/dd/yyyy')
								: data[key].text;
						renderInputToCell(range, val);
						col += 1;
					}
					return null;
				});
				context.sync();
				const endRow = row + 2;
				const endColumn = `${colName(col - 1)}${endRow}`;
				callback(data.sheetName, `${data.cellNumber}:${endColumn}`);
			})
			.catch(err => {
				return err;
			});
	}).catch(err => {
		return err;
	});
};

const spiltCellValue = splitValue => {
	const parts = splitValue && splitValue.match(/([A-Za-z]+)([0-9]+)/);
	const cellColumn = parts && parts[1];
	const cellRow = parts && parseInt(parts[2], 10);
	return { cellColumn, cellRow };
};

export const getDisplayCellValue = cellValue => {
	const dataSetTitleRange = spiltCellValue(cellValue);
	const dataSetTitleRow = dataSetTitleRange.cellRow - 1;
	const dataSetTitleColumn = dataSetTitleRange.cellColumn;
	return `${dataSetTitleColumn}${dataSetTitleRow}`;
};

export const renderMetricsResInSheet = async (inputData, result, callback) => {
	try {
		if (inputData.outputEndRange) {
			const outputSheetname = inputData.outputEndRange.sheetName;
			clearExcelData(inputData.outputEndRange.cellRange, outputSheetname);
		}
		await Excel.run(async context => {
			const sheet = context.workbook.worksheets.getItem(
				inputData.sheetName,
			);
			sheet.activate();
			// NOTE: to identify from where output column should render taking input header row cell and adding 5 rows init e.g input header starting at A3 then output will render from A8
			const inputRowCellParts =
				inputData.cellNumber &&
				inputData.cellNumber.match(/([A-Za-z]+)([0-9]+)/); // this will return cell array like ['A8', 'A', '8', index: 0, input: 'A8', groups: undefined]
			const cellColumnTxt = inputRowCellParts[1];
			const cellRowNum = parseInt(inputRowCellParts[2], 10) + 5; // adding 5 means after after input header 5th row.
			const columnCount =
				result.length > 0 ? Object.keys(result[0]).length : 0; // each row how many columns that length
			const startRange = sheet.getRange(
				`${inputRowCellParts[1]}${cellRowNum}`, // input starting at A3 -> A3+5 = A8
			);
			const endRange = startRange.getResizedRange(0, columnCount - 1); // to get ending column based on response array column e.g A8 to F8 or G8 etc.
			// Load the address of the range
			endRange.load('address');
			await context.sync();
			const outputEndColumnParts = endRange.address
				.split(':')[1]
				.match(/([A-Za-z]+)([0-9]+)/); // this will return cell array like ['F27', 'F', '27', index: 0, input: 'F27', groups: undefined]
			// const columnCount1 =
			// 	result.length > 0 ? Object.keys(result[0]).length : 0;
			const outPutEndCellNum =
				parseInt(outputEndColumnParts[2], 10) + result.length - 1; // identify ending row number of output e.g 7 rows renders in sheet (8 + 7 -1) = 14
			const outputEndRange = `${outputEndColumnParts[1]}${outPutEndCellNum}`;
			// Write grid data to a range
			const range = sheet.getRange(
				`${cellColumnTxt}${cellRowNum}:${outputEndRange}`,
			);
			range.values = result;
			range.format.autofitColumns();
			callback(inputData.sheetName, `${cellColumnTxt}${cellRowNum}:${outputEndRange}`);

			// Format the header row
			const headerRange = sheet.getRange(`${cellColumnTxt}${cellRowNum}:${outputEndColumnParts[0]}`);
			headerFormat(headerRange);

			await context.sync();
			console.log('Data rendered successfully!');
		});
	} catch (error) {
		console.error('Error rendering data to Excel:', error);
	}
};
// NOTE: below method is used to render TP dataset in case of RUN and RUNALL click from dataset manager page.
export const renderDatasetRunResponse = (inputData, result, refreshCellValue, callback) => {
	const outputSheetName = inputData.outputEndRange.sheetName;
	clearExcelData(inputData.outputEndRange.cellRange, outputSheetName);
	const outputCellNo = inputData.outputEndRange.cellRange.split(':')[0];
	const endOutputCellValue = inputData.outputEndRange.cellRange.split(':')[1];
	const outputStartRange = spiltCellValue(outputCellNo);
	const outputEndRange = spiltCellValue(endOutputCellValue);

	const startRow = outputStartRange.cellRow;
	const startRange = `${outputStartRange.cellColumn}${startRow}`;
	const endRow = startRow + result.length - 1;
	const endRange = `${outputEndRange.cellColumn}${endRow}`;

	Excel.run(context => {
		const sheet = context.workbook.worksheets.getItem(outputSheetName);
		return context
			.sync()
			.then(() => {
				const range = sheet.getRange(`${startRange}:${endRange}`);
				range.values = result;
				range.format.autofitColumns();
				const headerRange = sheet.getRange(`${startRange}:${outputEndRange.cellColumn}${startRow}`);
				headerFormat(headerRange);
				sheet.getRange(refreshCellValue).format.columnWidth = 161;
				return context.sync();
			})
			.then(() => {
				const newRange = `${startRange}:${endRange}`;
				callback(outputSheetName, newRange);
			});
	}).catch(err => {
		return err;
	});
};